enum Gender {
    Undisclosed = "Undisclosed",
    Other = "Other",
    Female = "Female",
    Male = "Male",
    NonBinary = "NonBinary",
    GenderFluid = "GenderFluid"
}

export { Gender }